angular.module('directives.croppic', []).directive('croppic', ["$timeout", function($timeout) {
  //alert("hola aaaaa");
  return {
    restrict: 'AE',
    //replace: true,
    require: 'ngModel',
    scope: {
      data: '=?',
      model: '=ngModel',
      options: '=?'
    },
    link: function(scope, element, attrs) {
       //alert("hola aaaaa 2"+JSON.stringify(scope.data));
      $timeout(function(){
        var id = Math.random().toString(36).substring(7);
        var query = _.assign({
          fileSize: 5,
          cropData: scope.data || {},
          cropUrl: '/api/articles/upload',
          uploadData: scope.data || {},
          uploadUrl: '/api/articles/upload',
          modal: true,
          processInline: true,
          loaderHtml: '<div class="loader bubblingG"><span id="bubblingG_1"></span><span id="bubblingG_2"></span><span id="bubblingG_3"></span></div> ',
          onAfterImgUploaded: function(data) {
            if(data.status === "error"){
              alert(data.message);
            }
            
            scope.model = data.data;
            if(typeof(scope.options.afterUploadedCallback) === 'function'){
              scope.options.afterUploadedCallback(data.data);
            }
            scope.$apply();
          }
        }, scope.options);
        new Croppic(id, $(element), query);
      });
    }
  };
}]);


// WEBPACK FOOTER //
// ./client/src/common/directives/croppic.js